module.exports = __webpack_public_path__ + "img/slider_comments_2.00b6fbad.jpg";